import React from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { fyMonths, fyOptions, monthLabel } from "./format";

const MonthPick = ({ value, onChange, months, testId, placeholder }) => (
  <Select value={value || "NONE"} onValueChange={(v) => onChange(v === "NONE" ? "" : v)}>
    <SelectTrigger className="w-[120px]" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      <SelectItem value="NONE">{placeholder}</SelectItem>
      {months.map(m => <SelectItem key={m} value={m}>{monthLabel(m)}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const ReportFilters = ({ projects, f, set, view }) => {
  const months = fyMonths(f.fy);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="report-filters">
      <Select value={f.pid} onValueChange={(v) => set({ pid: v })}>
        <SelectTrigger className="w-[230px]" data-testid="reports-project-picker"><SelectValue placeholder="Pick project" /></SelectTrigger>
        <SelectContent>
          {view === "monthly" && <SelectItem value="ALL" data-testid="reports-project-all">All projects</SelectItem>}
          {projects.map(p => <SelectItem key={p.id} value={p.id}>{p.project_code} · {p.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={f.fy || "ALL"} onValueChange={(v) => set({ fy: v === "ALL" ? "" : v, mode: "all", from: "", to: "" })}>
        <SelectTrigger className="w-[140px]" data-testid="reports-fy-picker"><SelectValue /></SelectTrigger>
        <SelectContent>
          {view !== "monthly" && <SelectItem value="ALL">All FYs</SelectItem>}
          {fyOptions().map(o => <SelectItem key={o} value={o}>{o}</SelectItem>)}
        </SelectContent>
      </Select>
      {view === "summary" && f.fy && (
        <>
          <Select value={f.mode} onValueChange={(v) => set({ mode: v, from: "", to: "" })}>
            <SelectTrigger className="w-[130px]" data-testid="reports-month-mode"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All months</SelectItem>
              <SelectItem value="single">Single month</SelectItem>
              <SelectItem value="range">From – To</SelectItem>
            </SelectContent>
          </Select>
          {f.mode !== "all" && <MonthPick value={f.from} onChange={(v) => set({ from: v })} months={months} testId="reports-month-from" placeholder={f.mode === "single" ? "Month" : "From"} />}
          {f.mode === "range" && <MonthPick value={f.to} onChange={(v) => set({ to: v })} months={months} testId="reports-month-to" placeholder="To" />}
        </>
      )}
      <Select value={f.status} onValueChange={(v) => set({ status: v })}>
        <SelectTrigger className="w-[160px]" data-testid="reports-status-picker"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="approved">Approved &amp; Paid</SelectItem>
          <SelectItem value="pending">Include pending</SelectItem>
        </SelectContent>
      </Select>
      <label className="flex items-center gap-2 text-xs text-slate-600 px-1">
        <Switch checked={f.hideZero} onCheckedChange={(v) => set({ hideZero: v })} data-testid="reports-hide-zero" /> Hide zero lines
      </label>
    </div>
  );
};
